import { render, staticRenderFns } from "./resulter.vue?vue&type=template&id=22d6b49a"
import script from "./resulter.vue?vue&type=script&lang=js"
export * from "./resulter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports